import { container } from 'tsyringe'
import { Mesh, MeshBasicMaterial, MeshStandardMaterial, Object3D, Vector2 } from 'three'
import { PhysicsLayerZ } from '../misc/constants'

import gsap, { Sine } from 'gsap'
import { Interface } from '@/shared/di/interface'
import type { IAssets } from '@/shared/di/interface/assets'
import { WalletType } from './wallet-manager'

export default class Tube {
  type: WalletType
  model: Object3D | undefined
  //closeButtonMesh: Mesh | undefined
  //canvasText: CanvasText
  name = ''
  available = false
  emitParticles = false
  animatedPulse = 0
  incomingAssets = false

  private isAnimating = false
  private pulseTween: gsap.core.Tween | undefined
  private tubeMesh: Mesh | undefined
  private logoMesh: Mesh | undefined
  private tubeMaterial: MeshStandardMaterial | undefined

  private tubeNeutralY = 0
  private dragNearExtraY = 0
  private tubePosition = new Vector2()

  constructor(type: WalletType, tubePosition: Vector2) {
    this.type = type
    this.tubePosition.copy(tubePosition)
    this.init()

    /*this.canvasText = new CanvasText()
    this.labelMesh!.material = new MeshBasicMaterial({
      map: this.canvasText.getTexture(),
      transparent: true,
      depthTest: false,
      depthWrite: false,
      side: DoubleSide
    })*/
  }

  setName(name: string) {
    if (name !== '') {
      //this.canvasText.setLeftText(name)
    } /*else {
      console.warn('no name')
    }*/
  }

  setAmount(amount: string) {
    if (amount !== '') {
      //this.canvasText.setRightText(amount)
    }
  }

  init() {
    const assets = container.resolve<IAssets>(Interface.IAssets)

    // add tube
    const tubeRoot = assets.getModel('tube')

    if (!tubeRoot) {
      return
    }

    this.model = tubeRoot.clone()

    this.model.position.y = this.tubePosition.y
    this.model.position.z = PhysicsLayerZ.Front

    this.model.scale.multiplyScalar(87)

    this.tubeMesh = this.model.children[0].children[0] as Mesh
    this.logoMesh = this.model.children[0].children[1] as Mesh

    this.tubeMesh.userData.enableBloom = true
    this.logoMesh.userData.enableBloom = true
    this.createTubeMaterial()
    this.tubeMesh.material = this.tubeMaterial!
    this.logoMesh.material = new MeshBasicMaterial({ color: 0xfffaeb })

    /*
    const handleFlagsUpdated = () => {}

    onFlagsUpdated.remove(handleFlagsUpdated)
    onFlagsUpdated.add(handleFlagsUpdated)
    */
  }

  createTubeMaterial() {
    const assets = container.resolve<IAssets>(Interface.IAssets)

    const material = new MeshStandardMaterial({
      map: this.type === WalletType.Tjing ? assets.getTexture('tube-diffuse') : assets.getTexture('tube-diffuse-grey'),
      vertexColors: true,
      envMapIntensity: 0.5,
      roughness: 0.17,
      metalness: 0
    })

    material.onBeforeCompile = shader => {
      shader.uniforms.isBloomRender = { value: 0 }
      shader.uniforms.glow = { value: 0 }
      shader.uniforms.extraGlow = { value: 0 }
      shader.uniforms.time = { value: 0 }

      shader.fragmentShader = shader.fragmentShader
        .replace(
          'void main() {',
          `
          uniform float glow; 
          uniform float extraGlow; 
          uniform float time; 
          uniform float isBloomRender; 
          void main() {
          `
        )

        //.replace('#include <color_fragment>', '')
        .replace(
          '#include <output_fragment>',
          `
          //sampledDiffuseColor
          //vec4 color = vec4(outgoingLight.rgb,1.0);
          vec4 color = vec4(sampledDiffuseColor.rgb,1.0);
          float isEmissive = (1.0-vColor.r);

          float glowTotal = 0.0;

          glowTotal += extraGlow * isEmissive;
          glowTotal += 0.2 * glow * isEmissive;

          color.rgb *= mix(1.0, 1.0 + mix(-0.6, 0.6, step(0.0001,glow)), isEmissive);

          color.rgb += totalSpecular*(1.0-isEmissive);
          
          gl_FragColor = mix(color+glowTotal*0.8, vec4(1.0) * glowTotal, isBloomRender);
          
        `
        )

      material.userData.shader = shader
    }

    this.tubeMaterial = material
  }

  open() {}

  close() {}

  reset() {}

  update(time: number, delta: number) {
    if (this.tubeMaterial) {
      this.tubeMaterial.userData.shader.uniforms.time.value = time
    }
  }

  setOnline(status: boolean) {}

  setAvailable(value: boolean) {
    this.available = value
    this.updateGlow()
  }

  setIncomingAssets(newStatus: boolean) {
    if (!newStatus && this.incomingAssets) {
      this.animateCoinOut()
    }

    this.incomingAssets = newStatus

    if (!this.incomingAssets) {
      this.killTween()
      this.updateGlow()
    } else {
      if (!this.pulseTween) {
        this.pulseTween = gsap.to(this, {
          duration: 0.7,
          animatedPulse: 1,
          repeat: -1,
          yoyo: true,
          ease: Sine.easeIn,
          onUpdate: () => {
            this.updateGlow()
          }
        })
      }
    }
  }

  killTween() {
    if (this.pulseTween) {
      this.pulseTween.kill()
      this.pulseTween = undefined
      this.animatedPulse = 0
    }
  }

  animateCoinOut() {
    if (!this.model) {
      return
    }
    gsap.to(this.model.position, {
      y: this.tubePosition.y - 1,
      duration: 0.2,
      ease: Sine.easeInOut,
      onComplete: () => {
        gsap.to(this.model!.position, {
          y: this.tubePosition.y,
          duration: 1
        })
      }
    })
  }

  setCoinNearTube(distance: number) {
    if (!this.model) {
      return
    }

    if (distance > 0) {
      if (gsap.getTweensOf(this.model.position).length > 0) {
        gsap.killTweensOf(this.model.position)
        this.isAnimating = false
      }
    }

    if (!this.isAnimating && distance > 0) {
      this.dragNearExtraY = Math.min(0.4, distance)
      this.model.position.y = this.tubePosition.y - this.dragNearExtraY
      this.tubeMaterial!.userData.shader.uniforms.extraGlow.value = this.dragNearExtraY / 0.5
    } else {
      this.dragNearExtraY += (0 - this.dragNearExtraY) * 0.4
      this.model.position.y += (this.tubePosition.y - this.model.position.y) * 0.1
      this.tubeMaterial!.userData.shader.uniforms.extraGlow.value +=
        (0 - this.tubeMaterial!.userData.shader.uniforms.extraGlow.value) * 0.1
    }
  }

  animateCoinIn() {
    if (!this.model) {
      return
    }

    this.isAnimating = true

    gsap.killTweensOf(this.model.position)

    gsap.to(this.model.position, {
      y: this.tubePosition.y + this.dragNearExtraY + 1,
      duration: 0.2,
      ease: Sine.easeInOut,
      onComplete: () => {
        this.dragNearExtraY = 0
        gsap.to(this.model!.position, {
          y: this.tubePosition.y,
          ease: Sine.easeOut,
          duration: 1,
          onComplete: () => {
            this.isAnimating = false
          }
        })
      }
    })
  }

  updateGlow() {
    if (this.tubeMaterial) {
      let lit = this.available ? 1 : 0
      if (this.incomingAssets) {
        lit = 1 - this.animatedPulse
      }
      this.tubeMaterial.userData.shader.uniforms.glow.value = lit
    }
  }

  destroy() {
    if (this.tubeMesh) {
      this.tubeMesh.geometry.dispose()
    }
    /*if (this.canvasText) {
      this.canvasText.destroy()
    }*/
    if (this.model && this.model.parent) {
      gsap.killTweensOf(this.model.position)
      this.model.parent.remove(this.model)
      this.model = undefined
    }
  }
}
